export interface StudentCreateRequest {
    firstName: string;
    lastName?: string | null;
    telegram?: string | null;
    email?: string | null;
    source: StudentSource
}

export interface StudentUpdateRequest {
    firstName?: string | null;
    lastName?: string | null;
    telegram?: string | null;
    email?: string | null;
    source?: StudentSource | null
}

export interface Student {
    id: number;
    firstName: string;
    lastName: string;
    telegram: string;
    email: string | null;
    enabled: boolean;
    source: StudentSource
}

export enum StudentSource {
    INSTAGRAM_SEARCH = 'INSTAGRAM_SEARCH',
    INSTAGRAM_REELS = 'INSTAGRAM_REELS',
    TIKTOK = 'TIKTOK',
    TELEGRAM_CHANNEL = 'TELEGRAM_CHANNEL',
    SOCIAL_RECOMMENDATION = 'SOCIAL_RECOMMENDATION',
    GOOGLE_YANDEX_SEARCH = 'GOOGLE_YANDEX_SEARCH',
    EVENT_WEBINAR = 'EVENT_WEBINAR',
    PERSONAL_RECOMMENDATION = 'PERSONAL_RECOMMENDATION',
    LONG_TIME_OBSERVER = 'LONG_TIME_OBSERVER',
    OTHER = 'OTHER'
}

export const StudentSourceNameMap = {
    [StudentSource.INSTAGRAM_SEARCH]: 'Поиск в Instagram',
    [StudentSource.INSTAGRAM_REELS]: 'Рилс/рекомендация поста в Instagram',
    [StudentSource.TIKTOK]: 'TikTok',
    [StudentSource.TELEGRAM_CHANNEL]: 'Telegram-канал Hola Julia Teach',
    [StudentSource.SOCIAL_RECOMMENDATION]: 'Рекомендация в соцсетях (сторис/пост/комментарии)',
    [StudentSource.GOOGLE_YANDEX_SEARCH]: 'Поиск в Google/Яндекс',
    [StudentSource.EVENT_WEBINAR]: 'С мероприятия/вебинара',
    [StudentSource.PERSONAL_RECOMMENDATION]: 'По рекомендации (друга/знакомого/преподавателя) ',
    [StudentSource.LONG_TIME_OBSERVER]: 'Вижу вас давно, решил/решила попробовать',
    [StudentSource.OTHER]: 'Другое'
}

export interface StudentView {
    id: number;
    firstName: string;
    lastName: string;
    telegram: string;
    email: string | null;
    enabled: boolean;
    source: StudentSource;
    registeredInBot: boolean;
}